import { useEffect, useRef } from 'react'
import { Bot, Volume2 } from 'lucide-react'
import { useT } from '../../i18n/useT'

export default function ChatMessages({ messages, loading, interim, ttsEnabled, onSpeak }) {
  const t = useT()
  const messagesEnd = useRef(null)

  useEffect(() => {
    messagesEnd.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages, loading, interim])

  return (
    <div className="chat-messages">
      {messages.length === 0 && !loading && (
        <div className="chat-welcome">
          <Bot size={40} className="chat-welcome-icon" />
          <p className="chat-welcome-title">{t('agent_welcome_title')}</p>
          <p className="chat-welcome-sub">{t('agent_welcome_sub')}</p>
        </div>
      )}

      {messages.map((m, i) => (
        <div key={i} className={`chat-bubble chat-bubble--${m.role}`}>
          {m.role === 'assistant' && <Bot size={16} className="chat-bubble-avatar" />}
          <div className="chat-bubble-content selectable">{m.content}</div>
          {m.role === 'assistant' && ttsEnabled && (
            <button
              className="btn-icon btn-icon--sm chat-bubble-speak"
              onClick={() => onSpeak(m.content)}
              aria-label={t('agent_speak')}
            >
              <Volume2 size={14} />
            </button>
          )}
        </div>
      ))}

      {loading && (
        <div className="chat-bubble chat-bubble--assistant">
          <Bot size={16} className="chat-bubble-avatar" />
          <div className="chat-bubble-content chat-typing">
            <span /><span /><span />
          </div>
        </div>
      )}

      {interim && <div className="chat-interim">{interim}</div>}

      <div ref={messagesEnd} />
    </div>
  )
}
